enum BackgroundJobStatus {
  Enqueued = "Enqueued",
  Processing = "Processing",
  Succeeded = "Succeeded",
  Failed = "Failed",
}
export default BackgroundJobStatus;
